import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './ConsentScreen.css';

const sessionConsentItems = [
  'Access to my camera',
  'Processing of facial images for gaze detection',
  'Temporary storage of session data for performance improvement',
  'Cloud processing of camera data & device data',
];

const partnerConsentItems = [
  "I'm providing consent on behalf of someone who cannot provide consent themselves",
];

function ConsentScreen() {
  const navigate = useNavigate();
  const [consents, setConsents] = useState(
    new Array(sessionConsentItems.length + partnerConsentItems.length).fill(false)
  );

  const allConsented = consents.every(Boolean);

  useEffect(() => {
    if (!allConsented) return;

    const inferenceUrl = process.env.REACT_APP_INFERENCE_URL;
    if (inferenceUrl) {
      fetch(`${inferenceUrl}/health`).catch(() => {});
    }

    if (!navigator.mediaDevices) {
      navigate('/intro');
      return;
    }
    navigator.mediaDevices
      .getUserMedia({ video: true })
      .then((stream) => {
        stream.getTracks().forEach((t) => t.stop());
        navigate('/intro');
      })
      .catch(() => {
        navigate('/intro');
      });
  }, [allConsented, navigate]);

  const toggleConsent = (index) => {
    setConsents((prev) => {
      const next = [...prev];
      next[index] = !next[index];
      return next;
    });
  };

  return (
    <div className="consent-container">
        <h2 className="consent-header">I consent to the following for this session:</h2>

        <div className="consent-list">
          {sessionConsentItems.map((text, i) => (
            <div className="consent-item" key={i} onClick={() => toggleConsent(i)}>
              <svg className="consent-circle" width="41" height="41" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="20.5" cy="20.5" r="20.5" fill={consents[i] ? '#4CAF50' : '#D9D9D9'} />
              </svg>
              <span className="consent-text">{text}</span>
            </div>
          ))}
        </div>

        <h3 className="consent-section-title">Conversation Partner Consent</h3>

        <div className="consent-list">
          {partnerConsentItems.map((text, i) => {
            const index = sessionConsentItems.length + i;
            return (
              <div className="consent-item" key={index} onClick={() => toggleConsent(index)}>
                <svg className="consent-circle" width="41" height="41" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="20.5" cy="20.5" r="20.5" fill={consents[index] ? '#4CAF50' : '#D9D9D9'} />
                </svg>
                <span className="consent-text">{text}</span>
              </div>
            );
          })}
        </div>
    </div>
  );
}

export default ConsentScreen;
